import { store } from '../index';
import { setAwaitingFileSelectionTrue, setFiles, setCheckedList } from './files/actionCreators';
import {
  setConfirmDialogCompleted,
  setActiveAccordionIndex,
  removeHeartbeatId,
} from './internal/actionCreators';

export function resetUploader() {
  store.dispatch(setAwaitingFileSelectionTrue());
  store.dispatch(setFiles([]));
  store.dispatch(setConfirmDialogCompleted(false));
  store.dispatch(setActiveAccordionIndex(0));
  store.dispatch(setCheckedList([]));
  store.dispatch(removeHeartbeatId(null));
}
